import fetchAPI from '../utils/service';

function getHomeBlockListRequest() {
  return {
    type: 'GET_HOME_BLOCK_LIST_REQUEST',
  };
}
function getHomeBlockListSuccess(payload) {
  return {
    type: 'GET_HOME_BLOCK_LIST_SUCCESS',
    payload,
  };
}
function getHomeBlockListFailure() {
  return {
    type: 'GET_HOME_BLOCK_LIST_FAILURE',
  };
}

function getHomeBlockList() {
  return async (dispatch) => {
    await dispatch(getHomeBlockListRequest());
    try {
      const res = await fetchAPI({
        endpoints: '/home-block',
      });
      if (res.status === 200) {
        await dispatch(getHomeBlockListSuccess(res.data));
      } else {
        await dispatch(getHomeBlockListFailure());
      }
    } catch (error) {
      await dispatch(getHomeBlockListFailure());
    }
  };
}

function createHomeBlockRequest() {
  return {
    type: 'CREATE_HOME_BLOCK_REQUEST',
  };
}
function createHomeBlockSuccess(data) {
  return {
    type: 'CREATE_HOME_BLOCK_SUCCESS',
    payload: {
      data,
    },
  };
}
function createHomeBlockFailure() {
  return {
    type: 'CREATE_HOME_BLOCK_FAILURE',
  };
}

function createHomeBlock({ data, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    await dispatch(createHomeBlockRequest());
    try {
      const res = await fetchAPI({
        method: 'POST',
        data,
        endpoints: '/home-block',
      });
      if (res.status === 201) {
        await dispatch(createHomeBlockSuccess(res.data));
        await response.success();
        dispatch(getHomeBlockList());
      } else {
        await dispatch(createHomeBlockFailure());
        await response.failure();
      }
    } catch (error) {
      await dispatch(createHomeBlockFailure());
      await response.failure();
    }
  };
}

function editHomeBlockRequest() {
  return {
    type: 'EDIT_HOME_BLOCK_REQUEST',
  };
}
function editHomeBlockSuccess(data, _id) {
  return {
    type: 'EDIT_HOME_BLOCK_SUCCESS',
    payload: {
      data,
      _id,
    },
  };
}
function editHomeBlockFailure() {
  return {
    type: 'EDIT_HOME_BLOCK_FAILURE',
  };
}

function editHomeBlock({ _id, data, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    await dispatch(editHomeBlockRequest());
    try {
      const res = await fetchAPI({
        method: 'PATCH',
        data,
        endpoints: `/home-block/${_id}`,
      });
      if (res.status === 200) {
        await dispatch(editHomeBlockSuccess(res.data, _id));
        await response.success();
        dispatch(getHomeBlockList());
      } else {
        await dispatch(editHomeBlockFailure());
        await response.failure();
      }
    } catch (error) {
      await dispatch(editHomeBlockFailure());
      await response.failure();
    }
  };
}

function deleteHomeBlockRequest() {
  return {
    type: 'DELETE_HOME_BLOCK_REQUEST',
  };
}
function deleteHomeBlockSuccess(_id) {
  return {
    type: 'DELETE_HOME_BLOCK_SUCCESS',
    payload: {
      _id,
    },
  };
}
function deleteHomeBlockFailure() {
  return {
    type: 'DELETE_HOME_BLOCK_FAILURE',
  };
}

function deleteHomeBlock({ _id, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    await dispatch(deleteHomeBlockRequest());
    try {
      const res = await fetchAPI({
        method: 'DELETE',
        endpoints: `/home-block/${_id}`,
      });
      if (res.status === 200) {
        await dispatch(deleteHomeBlockSuccess(_id));
        await response.success();
      } else {
        await dispatch(deleteHomeBlockFailure());
        await response.failure();
      }
    } catch (error) {
      await dispatch(deleteHomeBlockFailure());
      await response.failure();
    }
  };
}

export {
  getHomeBlockList,
  createHomeBlock,
  editHomeBlock,
  deleteHomeBlock,
};



// WEBPACK FOOTER //
// ./src/actions/home-block.js